import { GridCard as GridCardComponent } from './GridCard.component';
import GridCardLoader from './GridCardLoader';

const GridCard = Object.assign(GridCardComponent, {
  Loading: GridCardLoader,
});

export default GridCard;
